module.exports = __webpack_public_path__ + "static/assets/41835a2c99bdd753b68472735b2bd611.svg";